"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a;
/**
 * @hidden
 */
exports.nodata = 'dropdowns.nodata';
/**
 * @hidden
 */
exports.clear = 'dropdowns.clear';
/**
 * @hidden
 */
exports.messages = (_a = {},
    _a[exports.clear] = 'clear',
    _a[exports.nodata] = 'NO DATA FOUND.',
    _a);
